import { Box, Flex, Text } from '@gazin/ecommerce-ui'
import React, { memo } from 'react'
import UnavailableVariationIndicator from 'src/components/conteudoProdutos/productAttributes/unavailableVariationIndicator'
import { Variation } from 'src/services/marketplace-api/dtos'
import { theme } from 'src/styles/themes/default'
import { treatedVoltageValue } from 'src/util/products'
import { mapToProductAttributeButton } from '../mappers'
import { AttributeProps, SelectProductAttributeType } from '../types'
import { buttonBorder, buttonContentColor, buttonCursor } from './styles'
import { useWindowDimensions } from 'src/contexto/hooks/useWindowDimensions'

type SelectedAttributeProps = {
  slug: string
  value?: string
}

export type ProductAttributeProps = {
  attributes: AttributeProps[]
  children: JSX.Element
  selectAttribute: SelectProductAttributeType
  selectedAttribute: SelectedAttributeProps
  attributeLabel?: string
  availableVariations?: Variation[]
}

export const ProductAttributes: React.FC<ProductAttributeProps> = memo(
  ({
    attributes,
    children,
    selectAttribute,
    selectedAttribute,
    attributeLabel,
    availableVariations,
  }) => {
    const { width } = useWindowDimensions()
    const MARGIN_LEFT = 32
    const screenWidth = width - MARGIN_LEFT

    const availableAttributes = attributes.filter(
      (attribute) => attribute.available
    )
    const unavailableAttributes = attributes.filter(
      (attribute) => !attribute.available
    )

    const sortedAvailableAttributes = availableAttributes.sort((a, b) => {
      return a.valor.localeCompare(b.valor)
    })

    const sortedUnavailableAttributes = unavailableAttributes.sort((a, b) => {
      return a.valor.localeCompare(b.valor)
    })

    const sortedAttributes = sortedAvailableAttributes.concat(
      sortedUnavailableAttributes
    )

    return (
      <Flex flexDirection="column" marginBottom="0.5rem">
        {attributeLabel && selectedAttribute.value && (
          <Box>
            <Text color={theme.colors.grey[300]} marginBottom="0.25rem">
              {attributeLabel}: {selectedAttribute.value}
            </Text>
          </Box>
        )}

        <Flex
          flexWrap={['unset', 'wrap']}
          overflow="auto"
          width={[`${screenWidth}px`, 'unset']}
        >
          {sortedAttributes.map((attribute, key) => {
            const attributeButon = mapToProductAttributeButton(
              attribute,
              selectedAttribute.slug,
              selectAttribute,
              availableVariations
            )

            return (
              <Flex
                alignItems="center"
                backgroundColor="transparent"
                border={buttonBorder(attributeButon.active)}
                borderRadius="0.25rem"
                color={buttonContentColor(attributeButon.active)}
                cursor={buttonCursor(attributeButon.active)}
                fontSize="0.875rem"
                justifyContent="center"
                key={`${attribute.valor}-${key}`}
                marginBottom="0.72rem"
                marginRight="0.875rem"
                marginTop="0.18rem"
                minHeight="3.125rem"
                minWidth="4.875rem"
                onClick={attributeButon.handleOnClickEvent}
                position="relative"
              >
                {!attributeButon.available && (
                  <Box position="absolute" right="3" top="-1">
                    <UnavailableVariationIndicator />
                  </Box>
                )}
                {React.cloneElement(children, {
                  available: attribute.available,
                  image: attribute.image,
                  value: treatedVoltageValue(attribute.valor),
                })}
              </Flex>
            )
          })}
        </Flex>
      </Flex>
    )
  }
)
